import React, { createContext, useContext, useState } from "react";
import {
  getAuthToken,
  getAuthRole,
  getAuthUserId,
  getAuthUser,
  loginWithToken,
  logout as authLogout,
} from "../utils/authHelpers";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const token = getAuthToken();
    const role = getAuthRole();
    const userId = getAuthUserId();
    const users = getAuthUser();

    return {
      token: token ?? null,
      role: role ?? null,
      userId: userId ?? null,
      users: users ?? null,
    };
  });

  const login = ({ token, role, users, userId }) => {
    const actualUserId = userId ?? users?.id;
    loginWithToken({
      token,
      role,
      userId: actualUserId,
      user: users,
    });

    setAuth({
      token,
      role,
      userId: actualUserId,
      users,
    });
  };

  const logout = () => {
    authLogout();

    setAuth({
      token: null,
      role: null,
      userId: null,
      users: null,
    });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
